import { AxiosInstance, AxiosRequestConfig } from 'axios'

import { PartnerTagRepository } from './domain'

import { ConcernBodyTag } from '../../contracts/tag'
import { AxiosErrorHandler } from '../../foundation'

export class PartnerApiTag implements PartnerTagRepository {
  private errorHandler: AxiosErrorHandler

  constructor(private axios: AxiosInstance) {
    this.errorHandler = new AxiosErrorHandler()
  }

  getConcernBodyTagList = async (): Promise<ConcernBodyTag[]> => {
    const config: AxiosRequestConfig = {
      url: '/concern/partner/query/concern-body-parts/process',
      method: 'post',
    }
    try {
      const { data } = await this.axios.request<ConcernBodyTag[]>(config)
      return data
    } catch (error) {
      return this.errorHandler.handle(error)
    }
  }
}
